import type { BookEditionDetail, BookEditionSummary, ContributorSummary } from "@/types/domain"

const updatedAt = new Date("2026-08-10T15:00:00.000Z").toISOString()

export const demoContributors: ContributorSummary[] = [
  { id: "contributor-mill", name: "John Stuart Mill", nationality: "inglês", birthYear: 1806, deathYear: 1873 },
  { id: "contributor-gabriel", name: "Gabriel Schaf" },
  { id: "contributor-henriete", name: "Henriete Karam" },
  { id: "contributor-ana", name: "Ana Valéria Razera" },
  { id: "contributor-leticia", name: "Letícia de Paula" },
  { id: "contributor-thais", name: "Thais Ikuta" },
  { id: "contributor-vicente", name: "Vicente Pessôa" },
  { id: "contributor-lucas", name: "Lucas G.G. de Macêdo" },
  { id: "contributor-coletivo", name: "Coletivo editorial latino-americano" },
]

export const demoBooks: BookEditionDetail[] = [
  {
    id: "book-utilitarismo",
    title: "O utilitarismo",
    subtitle: "Uma defesa do princípio da maior felicidade",
    originalTitle: "Utilitarianism",
    imprintId: "imprint-filosofia",
    imprint: "Clube de Filosofia",
    publisher: "BARCA Editorial",
    publicationCity: "Porto Alegre",
    editionLabel: "1ª edição · brochura",
    publicationYear: 2026,
    originalPublicationYear: 1863,
    isbn: "9786584956315",
    pageCount: 224,
    format: "Impresso",
    dimensions: "14 × 21 cm",
    binding: "Brochura",
    language: "português",
    originalLanguage: "inglês",
    countryOfOrigin: "Inglaterra",
    genre: "Ensaio filosófico",
    version: 2,
    faoStatus: "AVAILABLE",
    authors: [demoContributors[0]],
    editors: [demoContributors[2]],
    technicalExtras: [
      { label: "Papel do miolo", value: "Pólen Soft 80 g/m²" },
      { label: "Projeto gráfico", value: "Vicente Pessôa e Lucas G.G. de Macêdo" },
    ],
    credits: [
      { id: "credit-mill-author", contributor: demoContributors[0], roleCode: "AUTHOR", roleName: "Autor", displayLabel: "Autor", position: 1 },
      { id: "credit-mill-translator", contributor: demoContributors[1], roleCode: "TRANSLATOR", roleName: "Tradução", displayLabel: "Tradução", position: 2 },
      { id: "credit-mill-editor", contributor: demoContributors[2], roleCode: "EDITOR", roleName: "Edição", displayLabel: "Edição e notas", position: 3 },
      { id: "credit-mill-reviewer", contributor: demoContributors[3], roleCode: "REVIEWER", roleName: "Revisão", displayLabel: "Revisão", position: 4 },
      { id: "credit-mill-proof", contributor: demoContributors[4], roleCode: "PROOFREADER", roleName: "Revisão de prova", displayLabel: "Revisão de prova", position: 5 },
      { id: "credit-mill-layout", contributor: demoContributors[5], roleCode: "LAYOUT", roleName: "Diagramação", displayLabel: "Diagramação", position: 6 },
      { id: "credit-mill-design-1", contributor: demoContributors[6], roleCode: "GRAPHIC_DESIGN", roleName: "Projeto gráfico", displayLabel: "Projeto gráfico", position: 7 },
      { id: "credit-mill-design-2", contributor: demoContributors[7], roleCode: "GRAPHIC_DESIGN", roleName: "Projeto gráfico", displayLabel: "Projeto gráfico", position: 8 },
    ],
    catalogRecord: {
      transcription: "Mill, John Stuart. O utilitarismo / John Stuart Mill; tradução de Gabriel Schaf. — 1. ed. — Porto Alegre: BARCA Editorial, 2026.",
      cataloger: "Equipe de catalogação BARCA",
      cdd: "171.5",
      cdu: "17.023.34",
      subjects: ["Utilitarismo", "Ética", "Filosofia inglesa"],
      notes: "Inclui notas e referências bibliográficas.",
      extraFields: [],
      version: 1,
      updatedAt,
    },
    fao: {
      status: "AVAILABLE",
      synopsis: "John Stuart Mill defende que as ações moralmente corretas são aquelas que promovem a maior felicidade para o maior número de pessoas.",
      context: "A obra foi produzida no contexto dos debates morais e políticos da Inglaterra vitoriana e reformula o utilitarismo clássico.",
      mainThemes: ["Princípio da maior felicidade", "Prazeres superiores e inferiores", "Justiça e direitos"],
      curiosities: "A obra apareceu primeiro em 1861, em três artigos na Fraser’s Magazine, e foi publicada como livro em 1863.",
      authorBiography: "John Stuart Mill (1806–1873) foi filósofo, economista político e uma das figuras centrais do liberalismo do século XIX.",
      mainWorks: [
        { title: "Sobre a liberdade", year: "1859" },
        { title: "Considerações sobre o governo representativo", year: "1861" },
        { title: "A sujeição das mulheres", year: "1869" },
      ],
      marketingLinks: [{ label: "Utilitarismo | Christian Dunker", url: "https://www.youtube.com/watch?v=JHjAOwqSEYg" }],
      version: 2,
      availableAt: updatedAt,
      updatedAt,
    },
    documents: [],
    createdAt: updatedAt,
    updatedAt,
  },
  {
    id: "book-antologia",
    title: "Antologia latino-americana",
    imprintId: "imprint-literatura",
    imprint: "Clube de Literatura",
    publisher: "BARCA Editorial",
    publicationYear: 2026,
    isbn: "9786559790807",
    pageCount: 288,
    format: "Impresso",
    version: 1,
    faoStatus: "DRAFT",
    authors: [demoContributors[8]],
    editors: [],
    technicalExtras: [],
    credits: [{ id: "credit-antologia-author", contributor: demoContributors[8], roleCode: "AUTHOR", roleName: "Autor", displayLabel: "Organização", position: 1 }],
    fao: {
      status: "DRAFT",
      synopsis: "Narrativas breves de diferentes países latino-americanos.",
      context: "",
      mainThemes: [],
      curiosities: "",
      authorBiography: "",
      mainWorks: [],
      marketingLinks: [],
      version: 1,
      updatedAt,
    },
    documents: [],
    createdAt: updatedAt,
    updatedAt,
  },
  {
    id: "book-vida-examinada",
    title: "A vida examinada",
    imprintId: "imprint-filosofia",
    imprint: "Clube de Filosofia",
    editionLabel: "Edição em preparação",
    version: 1,
    faoStatus: "MISSING",
    authors: [],
    editors: [],
    technicalExtras: [],
    credits: [],
    documents: [],
    createdAt: updatedAt,
    updatedAt,
  },
]

export function demoBookSummary(book: BookEditionDetail): BookEditionSummary {
  return {
    id: book.id,
    title: book.title,
    subtitle: book.subtitle,
    imprintId: book.imprintId,
    imprint: book.imprint,
    editionLabel: book.editionLabel,
    publicationYear: book.publicationYear,
    isbn: book.isbn,
    pageCount: book.pageCount,
    format: book.format,
    version: book.version,
    authors: book.authors,
    editors: book.editors,
    faoStatus: book.faoStatus,
  }
}
